import * as React from 'react'
import { FastField } from 'formik'

import { DebouncedTextField } from '@user/components/Formik'
import { SoldServiceAppDataString } from '@user/store/opportunity'

import { useGetCustomFieldProps } from '../hooks'

type Props = {
  disabled: boolean
  appData: SoldServiceAppDataString
}

export function StringField(props: Props) {
  const { appData, disabled } = props
  const fieldProps = useGetCustomFieldProps(appData)

  return (
    <FastField
      {...fieldProps}
      component={DebouncedTextField}
      disabled={disabled}
    />
  )
}
StringField.displayName = 'StringField'
